import React, { useEffect, useState, Fragment } from "react";
import aquilaLogo from "../assets/aquilaLogo.svg";
import userIcon from "../assets/userIcon.svg";
import CustomTextarea from "../components/CustomTextarea";
import { useNavigate, useParams } from "react-router-dom";
import api from "../api";
import { Dialog, Transition } from "@headlessui/react";

const RatingScreen = () => {
  const { token } = useParams();
  const [ride, setRide] = useState({});
  const [stars, setStars] = useState(0); // Para la calificación general
  const [ratings, setRatings] = useState({
    puntualidad: 0,
    comodidad: 0,
    seguridad: 0,
    comunicacion: 0,
    experiencia: 0,
  });
  const [comments, setComments] = useState("");

  const [fieldErrors, setFieldErrors] = useState({});
  const [error, setError] = useState(null);

  const [openModal, setOpenModal] = useState(false);

  const link = "https://g.page/r/CSr6p1Hyv_KOEAE/review";

  const [successMessage, setSuccessMessage] = useState("");

  const handleStarClick = (type, value) => {
    if (type === "general") {
      setStars(value);
    } else {
      setRatings((prev) => ({
        ...prev,
        [type]: value,
      }));
    }
  };

  useEffect(() => {
    async function fetchRide() {
      try {
        const rideData = await api.rides.getOne(token);
        setRide(rideData);
        setError("");
      } catch (error) {
        console.error("Error fetching ride details:", error);
        setError("Error al obtener los detalles del viaje.");
      }
    }
    fetchRide();
  }, [token]);

  const handleFormSubmit = async (event, type) => {
    event.preventDefault();
    setError(null);
    setFieldErrors({});

    const data = {
      token: token,
      ride: ride.id,
      driver: ride.driver.id,
      vehicle: ride.vehicle.id,
      client: ride.client.id,
      passenger: ride.passenger,
      comments: comments,
      general_rating: stars,
      punctuality: ratings["puntualidad"],
      comfort: ratings["comodidad del vehículo"],
      safety: ratings["seguridad"],
      communication: ratings["comunicación y atención"],
      overall_experience: ratings["experiencia general"],
    };

    try {
      await api.reviews.create(data);
      // Verifica si la calificación general es igual o mayor a 4
      if (stars >= 4) {
        setOpenModal(true); // Abre el modal
      } else {
        setSuccessMessage("¡Gracias por tu calificación!");
      }
    } catch (error) {
      if (error.message) {
        // Ajuste para errores específicos de campo según la estructura proporcionada
        const fieldErrors = error.message;
        setFieldErrors(fieldErrors);
      } else {
        setError("Error. Intenta nuevamente.");
      }
    }
  };

  const renderStars = (type, text) => (
    <div className="flex space-x-1">
      {[1, 2, 3, 4, 5].map((star) => (
        <button
          key={star}
          className={`text-[${text}] ${
            (type === "general" ? stars : ratings[type]) >= star
              ? "text-[#4AA785]"
              : "text-[#D9D9D9]"
          }`}
          onClick={() => handleStarClick(type, star)}
        >
          ★
        </button>
      ))}
    </div>
  );

  return (
    <div className="poppins-normal flex flex-col justify-center items-center bg-[#F8F9FB] w-full p-2 md:p-8 min-h-screen">
      <Transition appear show={openModal} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-50"
          onClose={() => {
            setOpenModal(false);
            setSuccessMessage("¡Gracias por tu calificación!");
          }}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-50" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4"
                enterTo="opacity-100 translate-y-0"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0"
                leaveTo="opacity-0 translate-y-4"
              >
                <Dialog.Panel className="relative bg-white rounded-lg shadow-lg w-full max-w-4xl p-8 ">
                  <Dialog.Title
                    as="h2"
                    className="poppins-medium text-lg font-bold text-[#1F384C] tracking-wider"
                  >
                    ¿Podrías calificarnos también aquí?
                  </Dialog.Title>
                  <div className="poppins-regular text-xs text-[#8F99A6]">
                    <br />
                    <a
                      href={link}
                      className="text-blue-500 hover:underline break-words"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {link}
                    </a>
                    <br />
                    <br />
                    ¡Muchas gracias por tu preferencia!
                  </div>
                  <button
                    onClick={() => {
                      setOpenModal(false);
                      setSuccessMessage("¡Gracias por tu calificación!");
                    }}
                    className="absolute top-4 right-4 text-[#000000] hover:text-gray-600 focus:outline-none"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="2"
                      stroke="currentColor"
                      className="w-8 h-8"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
      <img
        className="w-[60px] h-[60px] mb-5"
        src={aquilaLogo}
        alt="Logo de Aquila"
      />

      {successMessage ? (
        <div className="text-center p-8 bg-white rounded-2xl shadow-lg">
          <h3 className="text-xl text-[#595A5C]">{successMessage}</h3>
        </div>
      ) : (
        <div className="bg-white flex flex-col items-center shadow-lg rounded-lg p-6 w-full md:w-[763px]">
          {error && <p className="text-red-500 text-sm mb-4">{error}</p>}
          <h2 className="poppins-bold text-[17px] text-[#000000] text-center tracking-wider">
            Calificá tu viaje
          </h2>

          {/* Estrellas generales */}
          <div className="text-center mb-4 text-[40px]">
            {renderStars("general", "40px")}
            {fieldErrors.general_rating && (
              <p className="text-red-600 text-sm">
                {fieldErrors.general_rating[0]}
              </p>
            )}
          </div>

          {/* Información del conductor */}
          <p className="poppins-regular text-center text-[10px] text-[#909090] tracking-wider mb-4">
            Puntuá tu último viaje con:
          </p>
          <div className="flex flex-col items-center mb-4">
            <img
              src={userIcon}
              alt="Conductor"
              className="w-[36px] h-[36px] rounded-full"
            />
            <p className="inter-regular text-[8px] text-[#1C1C1C]">
              {ride?.driver?.name}
            </p>
          </div>

          {/* Rectángulos con criterios */}
          <div className="space-y-4 mb-[38px] w-[80%]">
            {[
              "puntualidad",
              "comodidad del vehículo",
              "seguridad",
              "comunicación y atención",
              "experiencia general",
            ].map((item) => (
              <div
                key={item}
                className="flex justify-between items-center bg-[#FBFBFB] rounded-[10px] p-3"
              >
                <span className="poppins-regular capitalize text-[#909090] text-[8px] tracking-wider">
                  {item.replace(/_/g, " ")}
                </span>
                {renderStars(item, "18px")}
                {fieldErrors.punctuality && (
                  <p className="text-red-600 text-sm">
                    {fieldErrors.punctuality[0]}
                  </p>
                )}
              </div>
            ))}
          </div>

          {/* Textarea */}
          <div className="w-full mb-4">
            <CustomTextarea
              placeholder="Escribí comentarios adicionales sobre el viaje"
              value={comments}
              onChange={(e) => setComments(e.target.value)}
            />
            {fieldErrors.comments && (
              <p className="text-red-600 text-sm">{fieldErrors.comments[0]}</p>
            )}
          </div>

          {/* Botón de enviar */}
          <button
            onClick={handleFormSubmit}
            className={`bg-[#BE202F] w-full text-white text-[10px] py-4 px-4 rounded-2xl tracking-wider poppins-medium focus:outline-none`}
          >
            Enviar reseña
          </button>
        </div>
      )}
    </div>
  );
};

export default RatingScreen;
